import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {withTranslation} from 'react-i18next';
import DatatableLoadMore from '../../../common/components/Datatable/DatatableLoadMore';
import gql from 'graphql-tag';
import {dateFormatFR} from '../../../utils';
import RowActionInvoices from './RowActionInvoicesAdmin';
import DisplayInvoiceStatus from './DisplayInvoiceStatus';
import DisplayAmount from '../../../common/components/DisplayAmount';
import {INVOICE_STATUS} from '../../../common/constants';
import SelectInvoicesStatus from './SelectInvoicesStatus';
import {MargedDiv} from '../../../common/components/Datatable/DatatableStyles';
import {Col, Row} from 'react-bootstrap';
import {flowRight as compose} from 'lodash';


const GRAPHQL_QUERY_INVOICES = gql`
  query invoices($criteria:CriteriaListInput, $additionalCriteria:InvoicesCriteriaListInput){
    invoices(criteria: $criteria, additionalCriteria: $additionalCriteria){
      rows{
        id
        amountDue
        amountPaid
        amountRemaining
        created
        currency
        user{
          id
          firstName
          lastName
        }
        status
        invoicePdf
        hostedInvoiceUrl
        dueDate
        paid
        total
        tax
        adminStripeUrl
      }
      id
      hasMore
    }
  }
`;

const displayUserName = value => {
  return value ? value.firstName + ' ' + value.lastName : '';
};


const columns = t => [
  {
    Header: t('amountDue'),
    accessor: 'amountDue',
    Cell: ({cell}) => <DisplayAmount amount={cell.value}/>,
  },
  {
    Header: t('date'),
    accessor: 'created',
    Cell: ({cell}) => dateFormatFR({date: cell.value}),
  },
  {
    Header: t('status.title'),
    accessor: 'status',
    Cell: ({cell}) => <DisplayInvoiceStatus status={cell.value} />,
  },
  {
    Header: t('dueDate'),
    accessor: 'dueDate',
    Cell: ({cell}) => cell.value ? dateFormatFR({date: cell.value}) : t('noDueDate'),
  },
  {
    Header: t('userOrMerchant'),
    accessor: 'user',
    Cell: ({cell}) => displayUserName(cell.value),
  },
  {
    Header: t('action'),
    Cell: ({cell}) => <RowActionInvoices invoice={cell.value}/>,
    accessor: row => row,
  },
];

const createStatusFilters = (statusFilter) => {
  if (Object.values(INVOICE_STATUS).includes(statusFilter)) {
    return {
      status: statusFilter,
    };
  }
};

const InvoicesAdmin = ({t}) => {
  const [statusFilter, setStatusFilter] = useState('default');

  const additionalFilters = (
    <MargedDiv>
      <SelectInvoicesStatus value={statusFilter} allowNull onChange={e => setStatusFilter(e.target.value)}/>
    </MargedDiv>
  );

  return (
    <div className="general-container">
      <Row>
        <Col xs={12}>
          <DatatableLoadMore
            query={GRAPHQL_QUERY_INVOICES}
            keyResult="invoices"
            columns={columns(t)}
            additionalCriteria={createStatusFilters(statusFilter)}
            additionalFilters={additionalFilters}
          />
        </Col>
      </Row>
    </div>
  );
};

InvoicesAdmin.propTypes = {
  t: PropTypes.func.isRequired,
};

export default compose(
  withTranslation('billing'),
)(InvoicesAdmin);
